import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { initOffice } from './services/office';
import './index.css';

initOffice().then(() => {
    ReactDOM.createRoot(document.getElementById('root')).render(
        <React.StrictMode>
            <App />
        </React.StrictMode>
    );
});
